import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import {
  HEADER_SMALL,
  LABEL_SMALL,
  PARAGRAPH,
  TITLES_MONO,
  TITLES_NORMAL
} from 'Shared/styles/designConstants';
import styled from 'styled-components';

const SIDE_MARGIN = '24px';

export const MenuTitle = styled.h3`
  ${TITLES_NORMAL.FT_01}
  padding: 32px 24px 6px;
`;

export const MenuContainer = styled.div`
  padding-bottom: 16px;
  position      : relative;

  :after {
    border-bottom: 1px solid ${ DESIGN_TOKENS.color.border.normal.value };
    content      : '';
    display      : block;
    bottom       : 0;
    left         : ${ SIDE_MARGIN };
    right        : ${ SIDE_MARGIN };
    position     : absolute;
  }
`;

export const Copyright = styled.div`
  ${LABEL_SMALL.DEFAULT}
  color : ${ DESIGN_TOKENS.color.text.secondary.value };
  margin: 20px ${ SIDE_MARGIN } 10px;
`;

export const GDPRLink = styled.a`
  ${PARAGRAPH.DEFAULT}
  color          : ${ DESIGN_TOKENS.color.text.link.value };
  display        : block;
  margin         : 24px ${ SIDE_MARGIN } 20px;
  text-decoration: underline;
`;

export const LogOutButton = styled.div`
  margin: 0 ${ SIDE_MARGIN };
`;

export const SidebarContainer = styled.div`
  position: sticky;
  overflow: auto;
  top     : 0;
`;

export const LogoContainer = styled.a`
  display        : flex;
  align-items    : center;
  justify-content: start;
  margin         : 50px 24px 23px;;
  gap            : 12px;
  cursor         : pointer;
  color          : ${DESIGN_TOKENS.color.text.normal.value};
  text-decoration: none;
  width          : 200px;
`;

export const LogoImage = styled.img`
  height: 40px;
  width : 40px;
`;

export const LogoText = styled.p`
  ${HEADER_SMALL.BOLD};
`;

export const UserData = styled.div`
  display        : flex;
  flex-direction : row;
  align-items    : center;
  justify-content: space-between;
  margin-left    : ${SIDE_MARGIN};
  margin-right   : ${SIDE_MARGIN};
  margin-bottom  : 48px;
`;

export const Divider = styled.div`
  border-left : 1.65px solid;
  height      : 24px;
  border-color: ${DESIGN_TOKENS.color.border.normal.value};
`;

export const DataPoint = styled.div`
  display        : flex;
  flex-direction : column;
  justify-content: center;
  align-items    : center;
  padding        : 8px;
  ${TITLES_MONO.FT_01}

  span {
    ${LABEL_SMALL.DEFAULT}
    color: ${DESIGN_TOKENS.color.text.secondary.value};
  }
`;

export const UserDataContainer = styled.div`
    border-bottom: 4px solid ${ DESIGN_TOKENS.color.border.normal.value };
    content      : '';
`;
